import Vue from 'vue';
import Vuex from 'vuex';
import audiences from './modules/audiences';
import auth from './modules/auth';
import campaigns from './modules/campaigns';
import catalog from './modules/catalog';
import catalogPages from './modules/catalogPages';
import categories from './modules/categories';
import config from './modules/config';
import content from './modules/content';
import designgroups from './modules/designgroups';
import drawers from './modules/drawers';
import emails from './modules/emails';
import guides from './modules/guides';
import industries from './modules/industries';
import lookup from './modules/lookup';
import marketing from './modules/marketing';
import orders from './modules/orders';
import outputs from './modules/outputs';
import print from './modules/print';
import products from './modules/products';
import promo from './modules/promo';
import promocodes from './modules/promocodes';
import reports from './modules/reports';
import reviews from './modules/reviews';
import templates from './modules/templates';
import topics from './modules/topics';
import users from './modules/users';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    audiences,
    auth,
    config,
    categories,
    templates,
    lookup,
    campaigns,
    emails,
    marketing,
    users,
    products,
    outputs,
    guides,
    print,
    orders,
    designgroups,
    industries,
    topics,
    catalog,
    drawers,
    reviews,
    content,
    catalogPages,
    promocodes,
    reports,
    promo
  }
});
